export enum ERole {
    Admin = 'ADMIN',
    Billing = 'BILLING',
    Matcher = 'MATCHER',
    Reviewer = 'REVIEWER',
    SuperAdmin = 'SUPER_ADMIN',
}
